const safety = [
    'ABS',
    'Alarm',
	'ASR (kontrola trakcji)',
    'Blokada skrzyni biegów',
    'Retarder',
]

const comfort = [
    '4x4',
    'Elektroniczny wtrysk',
    'Elektryczne lusterka',
    'Elektryczne szyby',
    'Kabina',
    'Klimatyzacja',
    'Komputer pokładowy',
    'Nawigacja GPS',
    'Ogrzewanie postojowe',
    'Tachograf',
]

export default [...safety,...comfort]
export {
    safety,
    comfort,
}